import React from 'react';
import { settingsLinks, useSettingsSections } from '../hooks';
import { NavLink } from 'react-router-dom';
import { PageHeader } from '@/shared/ui';
import styles from './SettingsPage.module.css';

export function SettingsPage() {
  const SETTINGS_TABS = [
    ...settingsLinks(useSettingsSections()),
    { label: 'Notifications', path: '/settings/notifications' },
  ];
  return (
    <div className={styles.page}>
      <PageHeader
        title="Settings"
        subtitle="Your practice, team, and the settings of each part of PracticeNova."
      />
      <div className={styles.tabs}>
        {SETTINGS_TABS.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              isActive ? `${styles.tab} ${styles.activeTab}` : styles.tab
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
